import * as React from 'react'

import { TableActionButtonInterface } from '@/modules/drivers/types/table'
import Tooltip from '../ToolTip'

const TableActionBar = ({
  actions,
}: {
  actions: TableActionButtonInterface[]
}) => {
  return (
    <div className="tw-w-full tw-rounded-t-lg tw-border-b-2 tw-border-primary tw-bg-content-background tw-py-[13px] tw-pl-4">
      <div className="tw-flex tw-items-center tw-gap-5">
        {actions.map((a, index) => (
          <Tooltip key={index} text={a.tooltip} disabled={a.disabled}>
            <img
              onClick={a.action}
              className="tw-h-4 tw-w-4"
              src={a.icon}
              alt={a.tooltip}
            ></img>
          </Tooltip>
        ))}
      </div>
    </div>
  )
}

export default TableActionBar
